export * from "./UIMessageConfig";
//# sourceMappingURL=index.js.map